const StorageFactory = (storage) => ({
  getItem(key, forceObject = false) {
    const item = storage.getItem(key);
    if (forceObject) {
      try {
        return JSON.parse(item);
      } catch (e) {
        return null;
      }
    }
    return item;
  },

  removeItem: (key) => storage.removeItem(key),

  setItem(key, value) {
    if (typeof value === 'object' && value !== null)
      storage.setItem(key, JSON.stringify(value));
    else
      storage.setItem(key, value);
  }
});


export const StorageService = StorageFactory(localStorage);
export const SessionService = StorageFactory(sessionStorage);

export default StorageService;
